// Global locale configuration - ALWAYS pt-BR
export const LOCALE_CONFIG = {
  locale: 'pt-BR',
  currency: 'BRL',
  timezone: 'America/Sao_Paulo'
} as const;

// Override browser locale detection to always use pt-BR
export const initializeLocale = () => {
  // Force pt-BR for all number/currency formatting
  if (typeof window !== 'undefined') {
    // Override Intl constructors to default to pt-BR
    const originalNumberFormat = Intl.NumberFormat;
    const originalDateTimeFormat = Intl.DateTimeFormat;
    
    // @ts-ignore
    Intl.NumberFormat = function(locales, options) {
      return originalNumberFormat.call(this, LOCALE_CONFIG.locale, options);
    };
    
    // @ts-ignore  
    Intl.DateTimeFormat = function(locales, options) {
      return originalDateTimeFormat.call(this, LOCALE_CONFIG.locale, options);
    };

    // Set document language
    document.documentElement.lang = 'pt-BR';
    
  }
};

// Utility functions that guarantee pt-BR formatting
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('pt-BR').format(value);
};

export const formatCurrencyInteger = (value: number): string => {
  const formatted = new Intl.NumberFormat('pt-BR').format(value);
  return `R$ ${formatted}`;
};

export const formatDate = (date: Date | string, options?: Intl.DateTimeFormatOptions): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('pt-BR', options).format(dateObj);
};